import { Callout } from '@dev-spendesk/grapes';

import { useTranslation } from 'common/hooks/useTranslation';

export const SpendingLimitReachedMessage = () => {
  const { t } = useTranslation('global');

  return (
    <Callout
      className="mt-24"
      variant="info"
      title={t(
        'control.approvalPolicyWidget.spendingLimitReachedMessage.title',
      )}
    >
      <span>
        {t(
          'control.approvalPolicyWidget.spendingLimitReachedMessage.description',
        )}
      </span>
    </Callout>
  );
};
